module.exports = __webpack_public_path__ + "static/img/21.6317545.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/eng/21.png
// module id = nIVB
// module chunks = 0